import React from "react";
import Grid from "@material-ui/core/Grid";
import { FieldArray } from "formik";
import * as Yup from "yup";
import { format, isValid } from "date-fns";

import {
  AutoSaveField as Field,
  Input,
  SelectAutocomplete,
  DatePicker
} from "../../../../components/Form";
import { DOC_REF_LENGTH, STATUS_OPTIONS } from "../../constants";
import { Divider } from "../Divider";
import { getInvalidMessage, getMinDateMessage } from "../../../../utils/getValidationMessage";
import { DATE_FORMAT } from "../../../../constants";
import { useStyles } from "./styled";

export const roEidFieldsSchema = () => ({
  eidDetails: Yup.array().of(
    Yup.object().shape({
      isEIDPingRequired: Yup.boolean(),
      signatoryName: Yup.string().nullable(),
      signatoryPingType: Yup.string().nullable(),
      signatoryEIDDate: Yup.date()
        .nullable()
        .min(new Date(1900, 0, 1), getMinDateMessage("EID ping date"))
        .max(new Date(), getInvalidMessage("EID ping date"))
        .typeError(getInvalidMessage("EID ping date")),
      signatoryEIDPingStatus: Yup.string().nullable(),
      signatoryEIDPingDocRef: Yup.string()
        .nullable()
        .max(DOC_REF_LENGTH, "Maximum ${max} characters allowed")
    })
  )
});

export const RoEidPingFields = ({ values }) => {
  const classes = useStyles();
  const changeDateProspectHandler = (_, value, path) =>
    isValid(value) && { [path]: format(value, DATE_FORMAT) };

  return (
    <FieldArray name="eidDetails">
      {arrayHelpers => (
        <Grid container spacing={3} className={classes.flexContainer}>
          {values.eidDetails.map((item, index) => {
            const prospectPath = `prospect.signatoryInfo[${item.index}]`;
            return (
              <React.Fragment key={index}>
                <Grid item sm={12} xs={12}>
                  <Field
                    name={`eidDetails[${index}].signatoryName`}
                    path={`${prospectPath}.signatoryName`}
                    label="Related Party"
                    component={Input}
                    InputProps={{
                      inputProps: { tabIndex: 0 }
                    }}
                    disabled
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Field
                    name={`eidDetails[${index}].signatoryPingType`}
                    path={`${prospectPath}.signatoryPingType`}
                    label="EID ping type"
                    component={SelectAutocomplete}
                    datalistId={"eidPingType"}
                    shrink={true}
                    tabIndex="0"
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Field
                    name={`eidDetails[${index}].signatoryEIDPingStatus`}
                    path={`${prospectPath}.signatoryEIDPingStatus`}
                    label="EID ping status"
                    component={SelectAutocomplete}
                    options={STATUS_OPTIONS}
                    datalistId={"eidPingStatus"}
                    tabIndex="0"
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Field
                    name={`eidDetails[${index}].signatoryEIDDate`}
                    path={`${prospectPath}.signatoryEIDDate`}
                    label="EID date"
                    component={DatePicker}
                    tabIndex="0"
                    changeProspect={changeDateProspectHandler}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Field
                    name={`eidDetails[${index}].signatoryEIDPingDocRef`}
                    path={`${prospectPath}.signatoryEIDPingDocRef`}
                    label="EID ping document reference no"
                    component={Input}
                    InputProps={{
                      inputProps: {
                        maxLength: DOC_REF_LENGTH,
                        tabIndex: 0
                      }
                    }}
                  />
                </Grid>
                <Grid item sm={12} xs={12}>
                  <Divider />
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
      )}
    </FieldArray>
  );
};
